module.exports = __webpack_public_path__ + "img/defi.52e10260.jpg";